import { AxiosResponseType } from '../../types/axiosTypes';
import api from '../axios';
import { fetchAuthSession } from '@aws-amplify/core';

export const createCompany = async (
  payload: any
): Promise<AxiosResponseType | null> => {
  const { tokens } = await fetchAuthSession();
  if (tokens) {
    const idToken = tokens.idToken?.toString();

    const res = await api.post<AxiosResponseType>(`/company/create_company`, {
      token: idToken,
      payload: payload,
    });
    return res.data;
  } else {
    throw new Error('User Not found');
  }
};

export const updateCompanyPaymentMethod = async (payload: string) => {
  try {
    const { tokens } = await fetchAuthSession();
    if (tokens) {
      const idToken = tokens.idToken?.toString();
      const res = await api.post<AxiosResponseType>(
        '/company/update_payment_method',
        {
          token: idToken,
          paymentSessionId: payload,
        }
      );
      return res.data;
    }
  } catch (err) {
    throw new Error('Payment method update error');
  }
};
